import { getDeviceProfileFields } from '@/utils/device'
import { safeFetchAPI, SafeFetchResponse } from '../index'
import { API_BASE } from './index'

export type DeviceLookupResponse = {
  contactIDs: string[]
  primaryContactID?: string
}

function sdkOriginBase(): string {
  return API_BASE.replace(/\/api\/v1\/?$/, '')
}

export async function lookupDeviceContacts(
  uid: string,
  deviceId: string
): Promise<SafeFetchResponse<DeviceLookupResponse>> {
  const profile = getDeviceProfileFields()
  return safeFetchAPI<DeviceLookupResponse>(`${sdkOriginBase()}/aiq-sdk/${uid}/devices/lookup`, {
    method: 'POST',
    // Must stay a CORS simple request: /aiq-sdk has no preflight headers for merchant origins.
    // The API decodes the body as JSON regardless of content type.
    headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
    payload: {
      deviceId,
      aiq_device_id: deviceId,
      deviceClass: profile.deviceClass,
      os: profile.os,
      browser: profile.browser,
      userAgent: profile.userAgent,
    },
    skipSessionId: true,
  })
}
